(function() {
    'use strict';

    angular.module('app.empresasFumigadoras', []);
})();
